import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import Select from "react-select";
import { Box, Button, Stack } from "@mui/material";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const VendorBalanceDetail = (props) => {
  const searchParams = new URLSearchParams(window.location.search);
  let iParam = searchParams.get("suptid") || 0;
  let iStartDate = searchParams.get("startdate") || "";
  let iEndDate = searchParams.get("enddate") || "";
  let iselectedperiod = searchParams.get("selectedperiod") || 1;
  let iAgingMethod = searchParams.get("agingmethod") || "Current";
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const navigate = useNavigate();
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalbalance, setTotalBalance] = useState(0);
  const [totalamount, setTotalAmount] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(iselectedperiod);
  const [selectedSupplier, setSelectedSupplier] = useState([iParam]);
  const [agingMethod, setAgingMethod] = useState(iAgingMethod);
  const [supoptions, setSupOptions] = useState([]);
  const [apiCalled, setApiCalled] = useState(false);
  const [callAPi, setCallApi] = useState(false);
  const [classicView, setClassicView] = useState(true);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    console.log(event.target.value);

    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    let SDate = startdate !== "" ? startdate : iStartDate;
    let EDate = enddate !== "" ? enddate : iEndDate;
    axios
      .get(
        `${config.reportsBaseUrl}/reports/vendorbalancedetail?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${SDate}&enddate=${EDate}&locationid=${locationid}&supplierid=${selectedSupplier}&agingmethod=${agingMethod}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            Address: el.Address ? el.Address : "",
            Terms: el.Terms ? el.Terms : "",
            Num: el.Num == 0 ? "" : el.Num,
            VendorMessage: el.VendorMessage ? el.VendorMessage : "",
            OpenBalance: Number(el?.OpenBalance) || 0,
            Amount: Number(el?.Amount) || 0,
          }));
          setResponseData(FilterData);
          setTotalAmount(
            FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.Amount) || 0),
              0
            )
          );
          setTotalBalance(
            FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.OpenBalance) || 0),
              0
            )
          );
        }
        setLoading(false);
        navigate("/vendor-balance-detail");
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (Number(iselectedperiod) > 0) {
      setStartDate(iStartDate);
      setEndDate(iEndDate);
      setSelectedSupplier(iParam ? [Number(iParam)] : []);
      setSelectReport(Number(iselectedperiod) || 1);
      setAgingMethod(iAgingMethod || "Current");
      setCallApi(true);
      //   apiCall();
    }
  }, []);

  useEffect(() => {
    if (callAPi) {
      setCallApi(false); // prevent repeated calls
      apicall(); // call your API
    }
  }, [callAPi]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const supOptions = supoptions.map((option) => ({
    value: option.ID,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    email: option.Email,
  }));

  const handleSupplierChange = (event) => {
    setSelectedSupplier(event.value);
  };

  if (iParam > 0 && apiCalled === false) {
    apicall();
    setApiCalled(true);
    console.log(startdate, enddate, "checkstartenddate11");
  }

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size: 100,
      Cell: ({ row }) =>
        moment(row.original.Date).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Vendor",
      accessorKey: "SupplierName",
      filterFn: "contains",
      size: 110,
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receiving-paybills/${row.original.TxnId}`
                : row.original?.TransactionType === "Receive" ||
                  row.original?.TransactionType === "	Vendor Credito"
                ? `/receiving-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Journal Entry"
                ? `/journal-entry/${row.original.TxnId}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.TxnId}`
                : `/Expense/${row.original.TxnId}`;

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: 110,
      Cell: ({ row }) =>
        moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`) ===
        "Invalid date"
          ? ""
          : moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: 110,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.Amount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      filterFn: "contains",
      size: 110,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.OpenBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      filterFn: "contains",
      size: 110,
      enableSorting: false,
      Cell: ({ row }) => {
        const Balance = parseFloat(row?.original?.Balance);

        if (isNaN(Balance) || Balance === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>
              {CurrencySymbols(
                Number(Balance),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      size: 150,
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
      size: 100,
    },
    {
      header: "Last Modified",
      accessorKey: "ModifiedDate",
      size: 150,
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.ModifiedDate;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "ModifiedBy",
      filterFn: "contains",
      size: 120,
    },

    {
      header: "Phone",
      accessorKey: "Phone",
      filterFn: "contains",
      size: 120,
    },
    {
      header: "Email",
      accessorKey: "Email",
      filterFn: "contains",
      size: 110,
    },
    {
      header: "Full Name",
      accessorKey: "FullName",
      filterFn: "contains",
      size: 110,
    },
    {
      header: "Address",
      accessorKey: "Address",
      filterFn: "contains",
      size: 100,
    },
    {
      header: "Company Name ",
      accessorKey: "CompanyName",
      filterFn: "contains",
      size: 110,
    },

    {
      header: "Terms",
      accessorKey: "Terms",
      filterFn: "contains",
      size: 100,
    },
    {
      header: "Description ",
      accessorKey: "MemoDescription",
      filterFn: "contains",
      size: 120,
    },
    {
      header: "Vendor Message",
      accessorKey: "VendorMessage",
      filterFn: "contains",
      size: 110,
    },
    // {
    //   header: "Supplier ID",
    //   accessorKey: "SupplierID",
    //   filterFn: "contains",
    //   size: 100,
    // },

    // {
    //   header : "Total Record",
    //   accessorKey : "TotalRecord"
    // },
  ]);

  const Classiccolumns = [
     {
      title: "Supplier Name",
      field: "SupplierName",
      headerFilter: "input",
      defaultVisible: true,
      frozen: true,
      // formatter: function (cell) {
      //   const data = cell.getData();
      //   const value = cell.getValue();

      //   // Apply red bold style if ParentCustomerID === 0
      //   if (data.ParentCustomerID == 0) {
      //     return `<span style="color: #1a2649; font-weight: bold;">${value}</span>`;
      //   }
      //   if (data.ParentCustomerID > 0) {
      //     return `<span class="tree-child">&nbsp;&nbsp;&nbsp;&nbsp;└── ${value}</span>`;
      //   }

      //   return value;
      // },
    },
    {
      title: "Date",
      field: "Date",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
   

    {
      title: "Terms",
      field: "Terms",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Transaction Type",
      field: "TransactionType",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.TransactionType || "";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.display = "flex";
        span.style.alignItems = "center";
        span.style.overflow = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.textOverflow = "ellipsis";
        span.style.fontWeight = "900";

        span.addEventListener("click", (e) => {
          e.preventDefault();
          const type = data.TransactionType;
          const saleId = data.TxnId;
          let url = `/Expense/${saleId}`; // default

          if (type === "Payment") {
            url = `/receiving-paybills/${saleId}`;
          } else if (type === "Receive" || type === "Vendor Credito") {
            url = `/receiving-receipt/${saleId}`;
          } else if (type === "Journal Entry") {
            url = `/journal-entry/${saleId}`;
          } else if (type === "Deposit") {
            url = `/bank-deposit/${saleId}`;
          }

          window.open(url, "_blank");
        });

        return span;
      },
    },

    {
      title: "Num",
      field: "Num",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Due Date",
      field: "DueDate",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Amount",
      field: "Amount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Open Balance",
      field: "OpenBalance",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },

    {
      title: "Balance",
      field: "Balance",
      headerFilter: "input",
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Created Date",
      field: "CreatedDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Modified Date",
      field: "ModifiedDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Last Modified By",
      field: "ModifiedBy",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Phone",
      field: "Phone",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Email",
      field: "Email",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Full Name",
      field: "FullName",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Company Name",
      field: "CompanyName",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Address",
      field: "Address",
      headerFilter: "input",
      // defaultVisible: true,
    },
     {
      title: "Description",
      field: "Description",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Vendor Message",
      field: "VendorMessage",
      headerFilter: "input",
      // defaultVisible: true,
    },
    
    // {
    //   title: "Billing Address",
    //   field: "BillingAddress",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
    // {
    //   title: "Shipping Address",
    //   field: "DeliveryAddress",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
    
   
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Vendor Balance Detail
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-2">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                  showasofdate={true}
                />
                {/* </div> */}
              </div>
            )}

            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Supplier
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={supOptions}
                    backspaceRemovesValue={false}
                    isClearable={true}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    isMulti={true}
                    value={supOptions.filter((b) =>
                      selectedSupplier.includes(b.value)
                    )}
                    // value={supOptions.find((e) => e.value === selectedSupplier)}
                    onChange={(selected) =>
                      setSelectedSupplier(selected?.map((e) => e.value) || [])
                    }
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Aging Method
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "Current"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "Current" : "ReportDate"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Current
                  </label>
                </div>
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "ReportDate"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "ReportDate" : "Current"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Report Date
                  </label>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="P">SonarPos</h6>
                    <p className="fw-bold p-regular">Vendor Balance Detail</p>
                    <div className="row mb-2 ">
                      <p>
                        {/* Date:{" "} */}
                        {enddate === ""
                          ? "All Data"
                          : "As of " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="table-responsive">
                  <div className="table mt-3"></div>
                  <div>
                    {ReportViewPermission == true ? (
                      <button
                        className="btn btn-secondary"
                        onClick={() => setClassicView(!classicView)}
                      >
                        {" "}
                        {classicView ? "Classic View" : "Morden View"}
                      </button>
                    ) : (
                      <></>
                    )}
                    {classicView ? (
                      <CommonTabular
                        Data={responseData}
                        columns={Classiccolumns}
                        Groupvalue={['SupplierName']}
                        Reportname={"Vendor Balance Detail"}
                        frozenRowvalue={0}
                        // layout={"fitDataFill"}
                        Onrefresh={() => apicall()}
                      />
                    ) : (
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Vendor Balance Detail"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={["SupplierName"]}
                        enableExpandAll={true}
                        enableExpanding={true}
                        expanded={true}
                        enableRowSelection={false}
                        columnsVisibility={{
                          CreatedDate: false,
                          CreatedBy: false,
                          ModifiedDate: false,
                          ModifiedBy: false,
                          //SupplierName: false,
                          Phone: false,
                          Email: false,
                          FullName: false,
                          BillingAddress: false,
                          CompanyName: false,
                          Terms: false,
                          MemoDescription: false,
                          VendorMessage: false,
                          Address: false,
                        }}
                      />
                    )}
                  </div>
                </div>
                <div style={{ textAlign: "start", marginTop: "5px" }}>
                  <>
                    <Stack style={{ fontWeight: "bold" }}>
                      Total Amount:{" "}
                      {CurrencySymbols(
                        Number(totalamount),
                        { CurrencySymbol },
                        FractionDigits
                      )}
                    </Stack>
                    <Stack style={{ fontWeight: "bold" }}>
                      Total Open Balance:{" "}
                      {CurrencySymbols(
                        Number(totalbalance),
                        { CurrencySymbol },
                        FractionDigits
                      )}
                    </Stack>
                  </>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VendorBalanceDetail;
